import { useSyncExternalStore } from 'react'

const noopSubscribe = () => () => {}

/**
 * Returns false during the prerender and the first (hydration) client render, true afterwards.
 * useSyncExternalStore keeps the prerendered markup and the hydration markup identical, so
 * gating on it never produces a hydration mismatch.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    noopSubscribe,
    () => true,
    () => false
  )
}
